"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _ActiveIntegration = _interopRequireDefault(require("../Settings/PersonalSettings/components/ActiveIntegration/ActiveIntegration"));

var _features = require("../Shared/store/features");

var actions = _interopRequireWildcard(require("./store/personalIntegration/personalIntegration.actions"));

var _IntegrationServices = _interopRequireDefault(require("./components/IntegrationServices/IntegrationServices"));

var _ChiliPiperIntegration = _interopRequireDefault(require("./components/ChiliPiperIntegration/ChiliPiperIntegration"));

var _useCalendarIntegration = require("./hooks/useCalendarIntegration");

var PersonalIntegration = function PersonalIntegration(_ref) {
  var strategy = _ref.strategy;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useCalendarIntegrati = (0, _useCalendarIntegration.useCalendarIntegration)(),
      currentIntegration = _useCalendarIntegrati.currentIntegration,
      isLoading = _useCalendarIntegrati.isLoading;

  var isChiliPiperEnabled = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.CHILIPIPER_INTEGRATION));
  var handleDisconnect = (0, _react.useCallback)(function () {
    return dispatch(actions.disconnectFromIntegration());
  }, [dispatch]);
  var handleUpdateEmailSetting = (0, _react.useCallback)(function (value) {
    return dispatch(actions.updateIntegration({
      type: 'email',
      value
    }));
  }, [dispatch]);
  var handleUpdateCalendarSetting = (0, _react.useCallback)(function (value) {
    return dispatch(actions.updateIntegration({
      type: 'calendar',
      value
    }));
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    p: 3
  }, currentIntegration && /*#__PURE__*/_react.default.createElement(_ActiveIntegration.default, (0, _extends2.default)({}, currentIntegration, {
    isLoading: isLoading,
    onUpdateEmail: handleUpdateEmailSetting,
    onUpdateCalendar: handleUpdateCalendarSetting,
    onDisconnect: handleDisconnect
  })), !currentIntegration && /*#__PURE__*/_react.default.createElement(_IntegrationServices.default, {
    strategy: strategy
  }), isChiliPiperEnabled && /*#__PURE__*/_react.default.createElement(_ChiliPiperIntegration.default, null));
};

PersonalIntegration.propTypes = {
  strategy: _propTypes.default.string
};
PersonalIntegration.defaultProps = {
  strategy: undefined
};
var _default = PersonalIntegration;
exports.default = _default;